export const parseFlagEnumValue = <const T extends readonly string[]>(
  value: unknown,
  values: T,
  fallback: T[number],
): T[number] => {
  return values.includes(value as T[number]) ? (value as T[number]) : fallback;
};
